export const VALIDATORS = {
  default: 'DEFAULT',
  loqate: 'LOQATE',
  custom: 'CUSTOM',
};
